/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";

import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idCampanha: string;
}

export function useDeleteCampanha() {
  const postData = async (props: Props) => {
    const INICIAR_INSCRICAO = `${leadsWebEnviroment}/common/campanha/excluir-campanha/v1/${props.idCampanha}`;
    const response = await instance.delete(INICIAR_INSCRICAO);
    return response?.data?.data;
  };
  const mutation = useMutation({
    mutationFn: postData,
    onSuccess: () => {},
    onError: () => {},
  });

  return mutation;
}
